<template>
	<div class="grid-main bg-purple ">
		<h2 style="float: left;width:1.5rem;line-height: 40px;">满意度列表</h2>
		<div class="lu_head" style="float: left;">
			<!--<el-tag
      v-for="item in items"
      :key="item.operatorNum"
      :type="item.type"
      @click="selectSatisfactionListByPage(item.operatorNum)"
      :class="{active : item.id===curId}"
      effect="light">
      {{ item.operatorName }}
    </el-tag>-->
			<span v-for="item in items" class="lu_list" :class="{lu_active : item.operatorNum===curId}" @click="selectSatisfactionListByPage(item.operatorNum)">
    		<img :src="item.logo"/>{{ item.operatorName }}</span>
    		
		<div class="point">

			<el-col :span="4" style="padding: 0; margin:10px 20px ;width:auto; ">
				<el-date-picker v-model="ayears" type="year" format="yyyy" value-format="yyyy" @change="pickerChangeFn" placeholder="请选择年份">
				</el-date-picker>
			</el-col>
			<el-col :span="4" style="padding: 0;margin:10px 0px ; margin-right: 20px;width:auto; ">

				<!--                  <h2 style="float: left;">第</h2>-->

				<!--                  <el-input v-model="aquarter" type="text" placeholder="请输入季度"></el-input>-->
				<el-select v-model="aquarter" placeholder="请选择季度" style=" ;padding: 0px 0px 0px;width: 120px" :clearable="true">

					<el-option v-for="item in quarters" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<!-- <h2 style="float: left;">季度</h2>&ndash;&gt;-->
			</el-col>
			<el-col :span="4 " style="padding: 0; margin-right: 10px; width:auto; ">
				<el-button type="info" style="width: 139px; height: auto; color: #fff ; text-align: center; margin-top:0px!important" @click="setabt()">查询</el-button>
			</el-col>
		</div>

		</div>

		<el-button type="primary" @click="dialogSatisfaction=true" style="margin-bottom: 30px;clear: both;">新增满意度选项</el-button>

		<div class="table-box">
			<el-table :data="SatisfactionList.list" height="550" border style="width: 100%;">
				<el-table-column prop="operatorName" label="企业" width="180">
				</el-table-column>
				<el-table-column label="季度" width="180">
					<template slot-scope="scope">
						{{scope.row.year}}年第({{scope.row.quarter}})季
					</template>
				</el-table-column>
				<el-table-column label="满意度">
					<template slot-scope="scope">
						{{scope.row.satisfactionNum}}%
					</template>
				</el-table-column>
				<el-table-column label="不满意度">
					<template slot-scope="scope">
						{{scope.row.discontentNum}}%
					</template>
				</el-table-column>

				<el-table-column fixed="right" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="success" @click="openscoreType(scope.row.id)">编辑</el-button>
						<el-button size="mini" type="danger" @click="openDelete(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination v-if="SatisfactionList.Satisfactiontotal>10" background layout="prev, pager, next" :page-size="SatisfactionList.SatisfactionpageSize" @current-change="setSatisfactionlist" :total="SatisfactionList.Satisfactiontotal">

			</el-pagination>
		</div>

		<el-dialog :visible.sync="dialogSatisfaction" :before-close="dialogroSatisfactionclose">
			<el-form ref="form" label-width="150px">
				<el-form-item label="企业:">
					<el-select v-model="SatisfactionAdds.curId" placeholder="请选择企业" style="float: left;">
						<el-option v-for="item in items" :key="item.operatorNum" :label="item.operatorName" :value="item.operatorNum">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="年份:">
					<el-date-picker v-model="SatisfactionAdds.year" type="year" format="yyyy" value-format="yyyy" @change="pickerChangeFn" placeholder="请选择年份" style="float: left;">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="季度:">
					<el-select v-model="SatisfactionAdds.quarter" class="aquarters" placeholder="请选择季度" style="float: left;" :clearable="true">

						<el-option v-for="item in quarters" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="满意度:">
					<el-input v-model="SatisfactionAdds.satisfactionNum" type="number" min="0" max="100" placeholder="请输入满意、单位（%）比如10%请输入10"></el-input>
				</el-form-item>
				<el-form-item label="不满意度:">
					<el-input v-model="SatisfactionAdds.discontentNum" type="number" min="0" max="100" placeholder="请输入不满意、单位（%）比如10%请输入10"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="SatisfactionAdd()">确认提交</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog :visible.sync="dialogupdatSatisfaction" :before-close="dialogroSatisfactionclose">
			<el-form ref="form" label-width="150px">
				<el-form-item label="企业:">
					<el-select v-model="SatisfactionUpdate.curId" placeholder="请选择企业" style="float: left;">
						<el-option v-for="item in items" :key="item.operatorNum" :label="item.operatorName" :value="item.operatorNum">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="年份:">
					<el-date-picker v-model="SatisfactionUpdate.year" type="year" format="yyyy" value-format="yyyy" @change="pickerChangeFn" placeholder="请选择年份" style="float: left;">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="季度:">
					<el-select v-model="SatisfactionUpdate.quarter" class="aquarters" placeholder="请选择季度" style="float: left;" :clearable="true">

						<el-option v-for="item in quarters" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="满意度:">
					<el-input v-model="SatisfactionUpdate.satisfactionNum" type="number" min="0" max="100" placeholder="请输入满意、单位（%）比如10%请输入10"></el-input>
				</el-form-item>
				<el-form-item label="不满意度:">
					<el-input v-model="SatisfactionUpdate.discontentNum" type="number" min="0" max="100" placeholder="请输入不满意、单位（%）比如10%请输入10"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="updateSatisfaction()">确认提交</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>

	</div>

</template>

<script>
	export default {
		name: "Satisfac",
		data() {
			return {
				quarters: [{
						id: 1,
						name: '第一季度',

					},
					{
						id: 2,
						name: '第二季度',

					},
					{
						id: 3,
						name: '第三季度',
					},
					{
						id: 4,
						name: '第四季度',
					},
				],
				items: [],

				dialogSatisfaction: false,
				SatisfactionList: {
					list: [],
					Satisfactionpage: 1,
					Satisfactiontotal: 0,
					SatisfactionpageSize: 10
				},

				SatisfactionAdds: {
					curId: '',
					year: '',
					quarter: '',
					satisfactionNum: '',
					discontentNum: '',
				},

				SatisfactionUpdate: {
					curId: '',
					year: '',
					quarter: '',
					satisfactionNum: '',
					discontentNum: '',
				},
				dialogupdatSatisfaction: false,
				curId: 1,
				Satisfactionid: 0,
				ayears: '',
				aquarter: '',
			}
		},
		beforeRouteEnter(to, from, next) {

			next((vm) => {

			});
		},
		created() {

		},
		mounted() {
			this.selectSatisfactionListByPage(1);
			this.selectAllOperator()
		},
		methods: {
			//获取所有企业
			selectAllOperator() {
				let that = this;
				this.$axios
					.get('/api/operator/selectAllOperator')	
					.then(function(res) {
						if(res.data.code == 200) {
							that.items = res.data.data;
							that.curId = res.data.data[0].operatorNum
						}

					})
			},
			pickerChangeFn(value) { // 日期选择器改变事件 ~ 解决日期选择器清空 值不清空的问题
				if(value === null) {
					this.ayears = value
					this.SatisfactionAdds.year = value
					this.SatisfactionUpdate.year = value

				}
			},
			dialogroSatisfactionclose() {
				this.SatisfactionUpdate = {
					curId: '',
					year: '',
					quarter: '',
					satisfactionNum: '',
					discontentNum: '',
				};
				this.dialogupdatSatisfaction = false;
				this.SatisfactionAdds = {
						curId: '',
						year: '',
						quarter: '',
						satisfactionNum: '',
						discontentNum: '',
					},
					this.dialogSatisfaction = false;

			},
			setabt() {
				if(this.ayears == '' || this.ayears == null) {
					this.$message.error('请选择年份！！！');
					return false;
				}

				this.selectSatisfactionListByPage(this.curId);
			},
			selectSatisfactionListByPage(index) {
				let that = this;
				this.curId = index;
				let Satisfactiondata = {
					page: this.SatisfactionList.Satisfactionpage,
					pageSize: this.SatisfactionList.SatisfactionpageSize,
					operatorNum: this.curId,
					year: this.ayears,
					quarter: this.aquarter,

				}
				this.$axios.defaults.withCredentials = true;
				this.$axios
					.post('/api/satisfaction/selectSatisfactionListByPage', Satisfactiondata)
					.then(function(res) {
						if(res.data.code == 200) {
							that.SatisfactionList.list = res.data.data.list;
							that.SatisfactionList.Satisfactiontotal = res.data.data.total;
						} else {
							that.$message.error(res.data.msg);
						}
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},

			setSatisfactionlist(Satisfactionpage) {
				this.SatisfactionList.Satisfactionpage = Satisfactionpage;
				this.selectSatisfactionListByPage(this.curId);
			},

			//新增满意度
			SatisfactionAdd() {
				let that = this;

				if(that.SatisfactionAdds.curId == '') {
					that.$message.error('请选择企业');
					return false;
				}
				if(that.SatisfactionAdds.year == '' || this.SatisfactionAdds.year == null) {
					that.$message.error('请选择年份');
					return false;
				}
				if(that.SatisfactionAdds.quarter == '') {
					that.$message.error('请选择季度');
					return false;
				}
				if(that.SatisfactionAdds.satisfactionNum == '') {
					that.$message.error('请输入满意度');
					return false;
				}
				if(that.SatisfactionAdds.discontentNum == '') {
					that.$message.error('请输入不满意度');
					return false;
				}
				let SatisfactionAddsa = {
					operatorNum: that.SatisfactionAdds.curId,
					year: that.SatisfactionAdds.year,
					quarter: that.SatisfactionAdds.quarter,
					satisfactionNum: that.SatisfactionAdds.satisfactionNum,
					discontentNum: that.SatisfactionAdds.discontentNum,
				}
				this.$axios
					.post('/api/satisfaction/addSatisfaction', SatisfactionAddsa)
					.then(function(res) {
						if(res.data.code == 500) {
							that.$message.error("新增满意度失败:" + res.data.msg);
							return false;
						} else if(res.data.code == 200) {
							that.$message({
								message: '新增意度成功',
								type: 'success'
							});
							//  this.show == true;
							window.setTimeout(() => {
								location.reload();
							}, 1000);
						}
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});

			},
			//编辑车辆管理

			selectSatisfactionById() {
				let that = this;
				let selectVehicleByIddata = {
					id: that.Satisfactionid
				}
				this.$axios
					.post('/api/satisfaction/selectSatisfactionById', selectVehicleByIddata)
					.then(function(res) {
						if(res.data.code == 200) {

//							that.SatisfactionUpdate.curId = Number(res.data.data.operatorNum);
							if(res.data.data.operatorNum==1){
								that.SatisfactionUpdate.curId = '美团'
							}else if(res.data.data.operatorNum==2){
								that.SatisfactionUpdate.curId = '哈啰'
							}else{
								that.SatisfactionUpdate.curId = '青桔'
							}
							that.SatisfactionUpdate.year = '' + res.data.data.year;
							that.SatisfactionUpdate.quarter = res.data.data.quarter;
							that.SatisfactionUpdate.satisfactionNum = res.data.data.satisfactionNum;
							that.SatisfactionUpdate.discontentNum = res.data.data.discontentNum;
							console.log(that.SatisfactionUpdate)
						}
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			openscoreType(Satisfactionid) {
				this.Satisfactionid = Satisfactionid;
				this.selectSatisfactionById();
				window.setTimeout(() => {
					this.dialogupdatSatisfaction = true;
				}, 200)

			},
			//修改车辆管理
			updateSatisfaction() {
				let that = this;

				if(that.SatisfactionUpdate.curId == '') {
					that.$message.error('请选择企业');
					return false;
				}
				if(that.SatisfactionUpdate.year == '' || that.SatisfactionUpdate.year == null) {
					that.$message.error('请选择年份');
					return false;
				}
				if(that.SatisfactionUpdate.quarter == '') {
					that.$message.error('请选择季度');
					return false;
				}
				if(that.SatisfactionUpdate.satisfactionNum == '') {
					that.$message.error('请输入满意度');
					return false;
				}
				if(that.SatisfactionUpdate.discontentNum == '') {
					that.$message.error('请输入不满意度');
					return false;
				}
				let updateSatisfactiondata = {
					id: that.Satisfactionid,
					operatorNum: that.SatisfactionUpdate.curId,
					year: that.SatisfactionUpdate.year,
					quarter: that.SatisfactionUpdate.quarter,
					satisfactionNum: that.SatisfactionUpdate.satisfactionNum,
					discontentNum: that.SatisfactionUpdate.discontentNum,
				}
				this.$axios
					.post('/api/satisfaction/updateSatisfaction', updateSatisfactiondata)
					.then(function(res) {
						if(res.data.code == 500) {
							that.$message.error("修改满意度失败" + res.data.msg);
							return false;
						} else if(res.data.code == 200) {
							that.$message({
								message: '修改满意度成功',
								type: 'success'
							});
							window.setTimeout(() => {
								location.reload();
							}, 1000);

						}
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},

			openDelete(SatisfactionIds) {
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.DeletedeleteSatisfaction(SatisfactionIds);
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			DeletedeleteSatisfaction(SatisfactionIds) {
				let that = this;
				let vSatisfactiona = {
					id: SatisfactionIds
				}

				this.$axios
					.post('/api/satisfaction/deleteSatisfaction', vSatisfactiona)
					.then(function(res) {

						if(res.data.code == 200) {
							that.$message({
								message: '删除成功',
								type: 'success'
							});
							window.setTimeout(() => {
								location.reload();
							}, 1000);
						} else {
							that.$message.error(res.data.msg);
						}
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},

		},
		watch: {

		},
	}
</script>

<style scoped>
	/deep/ .el-button--primary {
		width: auto!important;
		margin-bottom: 30px;
		margin-top: 0rem!important;
		float: right;
	}
	
	/deep/ .elupload .el-upload {
		border: 0px dashed #d9d9d9;
		border-radius: 0%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		float: right;
		margin-right: 10px;
	}
	
	.point {
		float: left;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		line-height: 0px;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-ms-flex-direction: row;
		flex-direction: row;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}
	
	.el-button--primary {
		margin-bottom: 0px
	}
	
	.el-date-editor {
		width: 150px
	}
	
	/deep/ .el-button--info {
		color: #fff;
		background-color: #409eff;
		border-color: #409eff;
	}
	
	
	
	.lu_head {
		float: left;
		overflow: hidden;
		width: calc(100% - 1.5rem);
	}
	
	.lu_list {
		font-size: 0.4rem;
		height: 40px;
		line-height:  40px;
		padding: 8px 0;
		border-radius: 5px;
		margin: 5px 0 5px 20px;
		max-width: 116px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		float: left;
		color: #909399;
		cursor: pointer;
	}
	
	.lu_list img {
		width:  0.4rem;
		height:  0.4rem;
		margin-right: 5px;
		position: relative;
		top: 0.05rem;
		filter: grayscale(90%);
		border-radius: 5px;
	}
	
	.lu_list:hover {
		color: #333;
	}
	
	.lu_list:hover img {
		filter: grayscale(0%);
	}
	
	.lu_active {
		color: #333 !important;
	}
	
	.lu_active img {
		filter: grayscale(0%) !important;
	}
	
</style>


// WEBPACK FOOTER //
// src/view/admin/Satisfac.vue